import { c as _c } from "react/compiler-runtime";
import { Calendar } from "lucide-react";
import EHRCard from "@/src/components/cards/ehr-cards/ehr-card";
import { formatHumanReadableDate } from "@/src/lib/utils/date-and-phone-utils";
import { Appointment } from "@/src/models/appointment";
interface EHRAppointmentRemindersCardProps {
  appointmentReminders: Appointment[];
}
export default function EHRAppointmentRemindersCard(t0) {
  const $ = _c(8);
  const {
    appointmentReminders
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Calendar />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== appointmentReminders.length) {
    t2 = appointmentReminders.length === 0 && <p className="text-sm text-muted-foreground">No appointment reminders available</p>;
    $[1] = appointmentReminders.length;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== appointmentReminders) {
    t3 = appointmentReminders.length > 0 && <div className="overflow-x-auto"><table className="w-full text-sm"><thead><tr className="border-b"><th className="text-left font-medium py-2">Date</th><th className="text-left font-medium py-2">Type</th><th className="text-left font-medium py-2">Status</th><th className="text-left font-medium py-2">Created</th><th className="text-left font-medium py-2">Notes</th></tr></thead><tbody>{appointmentReminders.map(_temp)}</tbody></table></div>;
    $[3] = appointmentReminders;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <EHRCard icon={t1} title="Appointment Reminders">{t2}{t3}</EHRCard>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(appointment) {
  return <tr key={appointment.id} className="border-b border-border/50"><td className="py-2">{appointment.appointmentDatetime ? formatHumanReadableDate(appointment.appointmentDatetime) : "TBD"}</td><td className="py-2">{appointment.ehrType || appointment.type || "N/A"}</td><td className="py-2">{appointment.ehrStatus || appointment.status || "N/A"}</td><td className="py-2">{appointment.appointmentCreatedAt ? formatHumanReadableDate(appointment.appointmentCreatedAt) : "N/A"}</td><td className="py-2 max-w-xs truncate" title={appointment.ehrReason || ""}>{appointment.ehrReason || "N/A"}</td></tr>;
}